import React from "react";
import { Alert, LinearProgress } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function DashboardDeferredBanner({ visible, preview = false, title, body }) {
  const { t } = useTranslation("settings");

  if (!visible) return null;

  return (
    <Alert severity="info" sx={{ mb: 2 }}>
      {title ||
        (preview
          ? t("dashboardPage.previewTitle", {
              defaultValue: "Visualização simplificada do período",
            })
          : t("dashboardPage.computingTitle", { defaultValue: "Gerando relatório…" }))}
      <br />
      {body ||
        (preview
          ? t("dashboardPage.previewBody", {
              defaultValue:
                "Mostramos apenas os indicadores principais enquanto o relatório completo é gerado em segundo plano. Você pode continuar navegando — avisaremos quando tudo estiver pronto. Os dados completos ficarão disponíveis por pelo menos 24 horas.",
            })
          : t("dashboardPage.computingBody", {
              defaultValue:
                "Esta consulta envolve muitos dados. Estamos processando em segundo plano e você será avisado quando estiver pronto. Os dados ficarão disponíveis por pelo menos 24 horas após a conclusão.",
            }))}
      <LinearProgress sx={{ mt: 1.5 }} />
    </Alert>
  );
}
